<div class="assessment-tags">
  @if (assessment.tags.length > 0) {
    <div class="tag-list" aria-label="付与済みタグ">
      @for (tag of assessment.tags; track tag.tagMasterId) {
        <span class="badge assessment-tag">{{ tag.name }}</span>
      }
    </div>
  }
</div>
